import { render, staticRenderFns } from "./BookmarkDetail.vue?vue&type=template&id=c85a107a&scoped=true&lang=pug&"
import script from "./BookmarkDetail.vue?vue&type=script&lang=ts&"
export * from "./BookmarkDetail.vue?vue&type=script&lang=ts&"
import style0 from "./BookmarkDetail.vue?vue&type=style&index=0&id=c85a107a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85a107a",
  null
  
)

export default component.exports